import { computed } from 'vue';
import store from '@/store';

/**
 * 区域信息处理 Hook
 */
export function useAreaInfo() {
    const rawRegionTree = computed(() => store.state.complaint.rawRegionTree);
    const deptInfo = computed(() => store.state.complaint.deptInfo);

    const findNodeByAreaId = (nodes, targetAreaId) => {
        for (const child of nodes) {
            if (String(child.areaId) === String(targetAreaId)) {
                return child;
            }
            if (child.children && child.children.length > 0) {
                const result = findNodeByAreaId(child.children, targetAreaId);
                if (result) return result;
            }
        }
        return null;
    };

    const getAreaInfo = (areaId) => {
        const tree = rawRegionTree.value;

        if (!areaId || !tree) {
            return {
                code: (deptInfo.value && deptInfo.value.areaCode) || "",
                name: (deptInfo.value && deptInfo.value.areaName) || ""
            };
        }

        if (String(areaId) === String(tree.areaId)) {
            return { code: tree.code, name: tree.name };
        }

        // 处理 self 前缀
        let targetId = areaId;
        if (String(areaId).startsWith("self")) {
            const realId = String(areaId).replace(/^self/, "");
            if (realId === String(tree.areaId)) {
                return { code: tree.code, name: tree.name };
            }
            targetId = realId;
        }

        const node = findNodeByAreaId(tree.children || [], targetId);
        return {
            code: node ? node.code : "",
            name: node ? node.name : ""
        };
    };

    const isValidCode = (code) => {
        return typeof code === 'string' && !!code && code.startsWith('53') && !code.endsWith('x');
    };

    const getGeoJsonKey = (code) => {
        if (!isValidCode(code)) return "yunnan";
        if (code === "530000") return "yunnan";
        return code.substring(0, 4) + "00";
    };

    return {
        getAreaInfo,
        isValidCode,
        getGeoJsonKey
    };
}
